import {
  CONTENT_FORMAT_FILTER_OPTIONS,
  MARKETPLACE_PLATFORM_OPTIONS,
} from '../../constants/marketplaceSearchFilters';
import { MARKETPLACE_CATEGORY_ALL } from './marketplaceKeywordSearch';
import {
  getMarketplaceCategoryOptionsForSuggestions,
  getMarketplaceSuggestionLabel,
} from './marketplaceSearchSuggestions';

export const HEADER_FACET_CATEGORY_COLUMN_LIMIT = 8;

export const HEADER_MARKETPLACE_FACET_CHIPS = Object.freeze([
  'all',
  'saved',
  'brandsYouFollow',
  'platforms',
  'categories',
  'format',
]);

export const HEADER_MARKETPLACE_FACET_LABELS = Object.freeze({
  platforms: 'Platforms',
  categories: 'Categories',
  format: 'Format',
  all: 'All',
  saved: 'Saved',
  brandsYouFollow: 'Brands you follow',
});

export function getVisibleHeaderFacetChips(userType) {
  return HEADER_MARKETPLACE_FACET_CHIPS.filter((facetId) => {
    if (facetId === 'brandsYouFollow') {
      return userType === 'influencer';
    }
    // Saved is visible for guests too (click sends them to login).
    return true;
  });
}

export function getHeaderFacetSelectionState({
  category = MARKETPLACE_CATEGORY_ALL,
  platforms = [],
  contentTypes = [],
  saved = false,
  followingBrands = false,
  userType = null,
} = {}) {
  const platformList = Array.isArray(platforms) ? platforms : [];
  const formatList = Array.isArray(contentTypes) ? contentTypes : [];
  const hasPlatformFilter = platformList.length > 0;
  const hasCategoryFilter = Boolean(category && category !== MARKETPLACE_CATEGORY_ALL);
  const hasFormatFilter = formatList.length > 0;
  const savedActive = userType === 'influencer' ? Boolean(saved) : Boolean(followingBrands);
  const brandsYouFollowActive = Boolean(followingBrands);
  const allSelected = !hasPlatformFilter
    && !hasCategoryFilter
    && !hasFormatFilter
    && !savedActive
    && !(userType === 'influencer' && brandsYouFollowActive);

  return {
    hasPlatformFilter,
    hasCategoryFilter,
    hasFormatFilter,
    savedActive,
    brandsYouFollowActive,
    allSelected,
  };
}

export function isHeaderFacetChipActive(facetId, selection, { isOpen = false } = {}) {
  if (facetId === 'platforms') return isOpen || selection.hasPlatformFilter;
  if (facetId === 'categories') return isOpen || selection.hasCategoryFilter;
  if (facetId === 'format') return isOpen || selection.hasFormatFilter;
  if (facetId === 'saved') return selection.savedActive;
  if (facetId === 'brandsYouFollow') return selection.brandsYouFollowActive;
  if (facetId === 'all') return selection.allSelected;
  return isOpen;
}

export function getHeaderCategoryColumns(userType, options = {}) {
  const { columnLimit } = options;
  const categories = getMarketplaceCategoryOptionsForSuggestions(userType);
  const mid = Math.ceil(categories.length / 2);
  const toItems = (list) => {
    const visible = columnLimit == null ? list : list.slice(0, columnLimit);
    return visible.map((value) => ({
      value,
      label: getMarketplaceSuggestionLabel(value),
    }));
  };
  return {
    top: toItems(categories.slice(0, mid)),
    more: toItems(categories.slice(mid)),
  };
}

export function getHeaderPlatformItems() {
  return [
    ...MARKETPLACE_PLATFORM_OPTIONS.map((value) => ({
      value,
      label: value,
    })),
    { value: '', label: 'Any platform' },
  ];
}

export function getHeaderFormatItems() {
  return [
    ...CONTENT_FORMAT_FILTER_OPTIONS.map(({ value, label }) => ({
      value,
      label,
    })),
    { value: '', label: 'Any format' },
  ];
}
